import Marquee from "react-fast-marquee";

const ITEMS = [
  "DDGS",
  "TEA",
  "SPICES",
  "FROM SOURCE TO DESTINATION",
  "NATURE'S BEST",
  "WORLD'S FINEST",
];

export const BrandMarquee = () => (
  <section
    data-testid="brand-marquee"
    className="border-y border-[#3D2817] bg-[#3D2817] py-6"
  >
    <Marquee speed={40} gradient={false} autoFill>
      {ITEMS.map((item, i) => (
        <div key={i} className="flex items-center">
          <span
            className="px-10 text-xl md:text-2xl font-medium uppercase tracking-[0.3em] text-[#F0E6C0]"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            {item}
          </span>
          <span className="text-lg text-[#E0A96D]">&#10022;</span>
        </div>
      ))}
    </Marquee>
  </section>
);
